export default "__VITE_ASSET__Cgo4Bre6__"